import { render, staticRenderFns } from "./photo-counter.vue?vue&type=template&id=41e04ba1&"
import script from "./photo-counter.vue?vue&type=script&lang=js&"
export * from "./photo-counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e04ba1')) {
      api.createRecord('41e04ba1', component.options)
    } else {
      api.reload('41e04ba1', component.options)
    }
    module.hot.accept("./photo-counter.vue?vue&type=template&id=41e04ba1&", function () {
      api.rerender('41e04ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/photo-counter.vue"
export default component.exports